// extracted by mini-css-extract-plugin
export default {"About":"About_About__kCeED","content":"About_content__rwAbf"};